export default __webpack_public_path__ + "static/media/Hatching.225bb1b9.svg";